document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-trigger--active');
        entry.target.classList.remove('scroll-trigger--offscreen');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Fallback to grab elements that might have missed the initial pass
  const initObserver = () => {
    document.querySelectorAll('.scroll-trigger--offscreen').forEach(el => {
      observer.observe(el);
    });
  };

  initObserver();
  
  // Re-run if Shopify injects new sections (like collection filtering)
  document.addEventListener('shopify:section:load', initObserver);
});
